import {User, UserState} from "@/modules/user/types";
import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {deleteUser, getUser, getUsers, saveUser, updateUser} from "@/services/user";

export const state: UserState = {
  user: {
    id: "",
    id_company: "",
    id_auth: "",
    name: "",
    position: "",
    phone: "",
    email: "",
  },
}

const actions: ActionTree<UserState, RootState> = {
  async GET_USER(_, id) {
    return await getUser(id);
  },
  async GET_USERS() {
    return await getUsers();
  },
  async SAVE_USER(_, user) {
    return await saveUser(user);
  },
  async UPDATE_USER(_, user) {
    return await updateUser(user);
  },
  async DELETE_USER(_, id) {
    return await deleteUser(id);
  }
}

const mutations: MutationTree<UserState> = {
  SET_USER(state, user: User) {
    state.user = user;
  },
}

const getters: GetterTree<UserState, RootState> = {
  USER(state): User {
    const {user} = state;
    return {...user};
  }
}

export const user: Module<UserState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
